<template>
    <div> 
        <base-header type="" class="rsgradient pb-3 pb-1 pt-3 pt-md-5">
        </base-header>
         <b-card style="margin: 20px">
             <b-card-header header-tag="header" class="p-1" role="tab">
                Mi Tarjeta MasterCard
            </b-card-header>
            <b-card-body>
                <div class="row form-group">
                    <div class="col-md-12 text-center">
                        <label v-text="model.WelcomeMessage"></label> 
                    </div>
                </div>

                <form-wizard color="#ff5955" backButtonText="Atras" ref="wizard" title subtitle :hide-buttons="true">
                    <template slot="step" scope="props">
                        <wizard-step :tab="props.tab" :transition="props.transition" :index="props.index"></wizard-step>
                    </template>
                    
                    <tab-content title="Aprobada" icon="fa fa-fw fa-flag" v-if="!model.IsRreprint"></tab-content>
                    <tab-content title="Impresa" icon="fa fa-fw fa-flag"></tab-content>
                    <tab-content title="En camino" icon="fa fa-fw fa-flag"></tab-content>
                    <tab-content title="Entregada" icon="fa fa-fw fa-flag"></tab-content>

                </form-wizard>

                <div class="text-center">
                    <img src="@/assets/card_landing.png" class="mx-auto d-block" width="40%" height="40%" />
                </div>
                <div class="row form-group" >
                    <div class="col-md-12 text-center">
                        <save-button text="Activar mi tarjeta" @click="activarMiTarjeta" v-if="model.CanActivateMyCard"></save-button>
                    </div>
                </div>
            </b-card-body>
        </b-card> 
    </div>
</template>

<style>
</style>

<script>
    import Vue from 'vue'
    import vSelect from 'vue-select'
    Vue.component('v-select', vSelect)
    import 'vue-select/dist/vue-select.css';
    import axiosHelpers from '@/helpers/axiosHelpers';
    import notificationHelpers from '@/helpers/notificationHelpers';
    import { FormWizard, TabContent, WizardStep } from "vue-form-wizard";
    import "vue-form-wizard/dist/vue-form-wizard.min.css";

    export default {
        components: { 
            FormWizard,
            TabContent,
            WizardStep
        },
        props: {
            welcomeMessage: String,
            requestState: Number,
            isReprint: Boolean
        },
        data(){
            return{
                model: {      
                    WelcomeMessage: this.welcomeMessage,
                    RequestState: this.requestState,
                    CanActivateMyCard: false ,
                    IsRreprint: this.isReprint
                },
            }
        },
        methods: {
            activarMiTarjeta() {
                let context = this
                context.$router.push("ActivateMyCard");
            }
        },
        mounted()
        {
            let context = this;

            // -- Si es Reimpresion
            if(context.model.IsRreprint)
            {
                context.model.CanActivateMyCard = true;
            }
            else
            {
                // -- Entregada, Impresa, En Camino
                context.model.CanActivateMyCard = (context.$store.getters.MastercardEntregado == context.model.RequestState 
                || context.$store.getters.MastercardImpresa == context.model.RequestState || context.$store.getters.MastercardEnCamino == context.model.RequestState);
            }
            
            // -- Impresa
            if(context.model.RequestState == context.$store.getters.MastercardImpresa)
            {
                context.$refs.wizard.nextTab();
            }
            // -- En Camino
            else if(context.model.RequestState == context.$store.getters.MastercardEnCamino)
            {
                context.$refs.wizard.nextTab();
                context.$refs.wizard.nextTab();
            }
            // -- Entregada
            else if(context.model.RequestState == context.$store.getters.MastercardEntregado)
            {
                context.$refs.wizard.nextTab();
                context.$refs.wizard.nextTab();
                context.$refs.wizard.nextTab();
            }
        }
    }
</script>